import React from 'react';
import { Link, Redirect } from "react-router-dom";
import {
	Card,
	Row,
	Col,
	Form,
	Input,
	Button,
	Select,
	Switch,
	Checkbox,
	message,
	Alert,
	Divider,
	Typography,
} from 'antd';
import {
	DiffOutlined,
	SaveOutlined,
	CloseCircleOutlined,
	AppstoreOutlined,
	TagOutlined,
	ArrowLeftOutlined,
	EditOutlined,
	PlusCircleOutlined,
	ControlOutlined,
	UnorderedListOutlined,
	CalendarOutlined,
} from '@ant-design/icons';
import moment from 'moment';

import Config from '../../Config';
import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
	extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	apiUrl: { preview: "master/api/layanan/" },
	pageUrl: { data: '/admin/layanan/' },
};

const config = new Config();

const FIELD_STYLE = { borderRadius: 8, height: 40 };

const BOOL_FIELDS = [
	{ name: 'bbnkb_i',  label: 'BBNKB I' },
	{ name: 'bbnkb_ii', label: 'BBNKB II' },
	{ name: 'pkb',      label: 'PKB' },
	{ name: 'swdkllj',  label: 'SWDKLLJ' },
	{ name: 'adm_stnk', label: 'ADM STNK' },
	{ name: 'adm_tnkb', label: 'ADM TNKB' },
];

class FormLayanan extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errComponent: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,
			aksi: 'tambah',
			method: 'post',
			idLama: '',
			field_requirements: {},
			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.loadMasterList();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	loadMasterList() {
		this.setState({ errComponent: false });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + 'field_requirements/')
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					this.setState({ field_requirements: responseMsg });
				} else {
					this.setState({ errComponent: true });
				}
				if (this.props.match.params.id !== undefined) {
					this.preview(this.props.match.params.id);
				}
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	async preview(id) {
		message.loading({ content: 'Memuat data...', duration: 0, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					this.formRef.current.setFieldsValue(data);
					for (var key in data) {
						const dateRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4}$/;
						const dateTimeRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;
						if (dateRegex.test(data[key])) {
							this.formRef.current.setFieldsValue({ [key + '_picker']: moment(data[key], 'DD-MM-YYYY') });
						} else if (dateTimeRegex.test(data[key])) {
							this.formRef.current.setFieldsValue({ [key + '_picker']: moment(data[key], 'DD-MM-YYYY HH:mm:ss') });
						}
						if (key === 'field_requirements') {
							this.setState({ field_requirements: data[key] });
						}
					}
					message.destroy();
					this.setState({ aksi: 'edit', method: 'put', idLama: id + '/' });
				} else {
					const errTitle = 'Gagal memuat data';
					this.setState({ errTitle, errMsg: data });
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handleSubmit = (values) => {
		const datas = { ...values, field_requirements: this.state.field_requirements };
		this.postData(datas);
	}

	async postData(datas) {
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.setState({ errTitle: '', errMsg: '' });
		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
			.then((action) => {
				this.setState({ loadingButton: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
				} else {
					const errTitle = 'Gagal menyimpan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handleCheckbox = (e, key) => {
		this.setState(prev => ({
			field_requirements: { ...prev.field_requirements, [key]: e.target.checked },
		}));
	};

	render() {
		if (this.props.isRedirect) {
			return <Redirect to={configClass.pageUrl.data} />;
		}

		const { isMobile, aksi, errMsg, errTitle, loadingButton, errComponent, field_requirements } = this.state;
		const isEdit = aksi === 'edit';
		const pageTitle = isEdit ? 'Edit Layanan' : 'Tambah Layanan';
		const colSpan = isMobile ? 24 : 12;

		return (
			<div>
				<Helmet>
					<title>{pageTitle + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-layanan-wrap .ant-form-item-label > label {
							font-weight: 600; color: #374151; font-size: 13px;
						}
						.form-layanan-wrap .ant-input,
						.form-layanan-wrap .ant-select-selector {
							border-radius: 8px !important;
						}
						.form-layanan-wrap .ant-input:focus,
						.form-layanan-wrap .ant-select-focused .ant-select-selector {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Form
					layout="vertical"
					name="fdata"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					className="form-layanan-wrap"
				>
					<Card
						style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden', maxWidth: 780 }}
						bodyStyle={{ padding: 0 }}
					>
						{/* ── Header ── */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex', alignItems: 'center', gap: 16,
						}}>
							<div style={{
								width: 52, height: 52, borderRadius: 14, flexShrink: 0,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex', alignItems: 'center', justifyContent: 'center',
							}}>
								{isEdit
									? <EditOutlined style={{ color: '#fff', fontSize: 24 }} />
									: <PlusCircleOutlined style={{ color: '#fff', fontSize: 24 }} />
								}
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>{pageTitle}</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
									{isEdit ? 'Ubah konfigurasi layanan' : 'Isi formulir untuk menambah layanan baru'}
								</div>
							</div>
							<Link to={configClass.pageUrl.data}>
								<Button
									icon={<ArrowLeftOutlined />}
									style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 8, flexShrink: 0 }}
								>
									{!isMobile && 'Kembali'}
								</Button>
							</Link>
						</div>

						{/* ── Section: Informasi Layanan ── */}
						<div style={{
							padding: '14px 24px',
							background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
							borderBottom: '1.5px solid #d0dff5',
							display: 'flex', alignItems: 'center', gap: 10,
						}}>
							<AppstoreOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
							<Text strong style={{ fontSize: 14, color: '#0f2847' }}>Informasi Layanan</Text>
						</div>

						<div style={{ padding: '20px 28px 4px' }}>
							<Row gutter={[16, 0]}>
								<Col span={colSpan}>
									<Form.Item
										label={<span><AppstoreOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nama</span>}
										name="nama"
										rules={[{ required: true, message: 'Nama harus diisi' }]}
									>
										<Input placeholder="Nama layanan..." style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col span={colSpan}>
									<Form.Item
										label={<span><TagOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Kode</span>}
										name="kode"
										rules={[{ required: true, message: 'Kode harus diisi' }]}
									>
										<Input placeholder="Kode layanan..." style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item
										label={<span><UnorderedListOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Field Wajib</span>}
										name="field_wajib"
										rules={[{ required: true, message: 'Field wajib harus dipilih' }]}
									>
										<Select placeholder="Pilih field wajib..." style={{ borderRadius: 8 }}>
											<Select.Option value={1}>Notice Akhir</Select.Option>
											<Select.Option value={2}>Tanggal Kwitansi</Select.Option>
											<Select.Option value={3}>Tanggal Fiskal</Select.Option>
											<Select.Option value={4}>Tanggal Faktur</Select.Option>
										</Select>
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item
										label={<span><CalendarOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Tanggal PKB Ikut Tanggal Pendaftaran</span>}
										name="pkb_mulai_hari_pendaftaran"
										valuePropName="checked"
										tooltip="Kalau aktif, tanggal PKB (masa pajak baru) otomatis mengikuti tanggal hari pendaftaran dilakukan, menimpa tanggal lama yang tersimpan. Dipakai layanan yang selalu memulai periode pajak baru dari nol (kendaraan baru, mutasi masuk, hibah/warisan, eks CC/CD/BDN, dll)."
									>
										<Switch
											checkedChildren="Ya"
											unCheckedChildren="Tidak"
											style={{ background: undefined }}
										/>
									</Form.Item>
								</Col>
							</Row>
						</div>

						{/* ── Section: Komponen Layanan ── */}
						<div style={{
							padding: '14px 24px',
							background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
							borderTop: '1.5px solid #d0dff5',
							borderBottom: '1.5px solid #d0dff5',
							display: 'flex', alignItems: 'center', gap: 10,
						}}>
							<ControlOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
							<Text strong style={{ fontSize: 14, color: '#0f2847' }}>Komponen Layanan</Text>
						</div>

						<div style={{ padding: '20px 28px 4px' }}>
							<Row gutter={[16, 0]}>
								{BOOL_FIELDS.map(({ name, label }) => (
									<Col key={name} xs={12} sm={8} md={8}>
										<Form.Item
											label={<Text style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>{label}</Text>}
											name={name}
											valuePropName="checked"
											rules={[{ required: true, message: 'Harus dipilih' }]}
										>
											<Switch
												checkedChildren="Ya"
												unCheckedChildren="Tidak"
												style={{ background: undefined }}
											/>
										</Form.Item>
									</Col>
								))}
							</Row>
						</div>

						{/* ── Section: Field Requirements ── */}
						{Object.keys(field_requirements).length > 0 && (
							<>
								<div style={{
									padding: '14px 24px',
									background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
									borderTop: '1.5px solid #d0dff5',
									borderBottom: '1.5px solid #d0dff5',
									display: 'flex', alignItems: 'center', gap: 10,
								}}>
									<UnorderedListOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
									<Text strong style={{ fontSize: 14, color: '#0f2847' }}>Field Requirement</Text>
								</div>
								<div style={{ padding: '16px 28px 8px' }}>
									<Row gutter={[8, 4]}>
										{Object.keys(field_requirements).map((key) => (
											<Col key={key} xs={12} sm={8} md={6}>
												<Checkbox
													checked={field_requirements[key]}
													onChange={(e) => this.handleCheckbox(e, key)}
													style={{ fontSize: 12, color: '#374151' }}
												>
													{key.replace(/_/g, ' ')}
												</Checkbox>
											</Col>
										))}
									</Row>
								</div>
							</>
						)}

						{/* ── Footer tombol ── */}
						<Divider style={{ margin: 0 }} />
						<div style={{
							padding: '16px 28px',
							display: 'flex', gap: 10,
							justifyContent: isMobile ? 'stretch' : 'flex-end',
							flexDirection: isMobile ? 'column' : 'row',
							background: '#fafafa',
						}}>
							<Link to={configClass.pageUrl.data} style={isMobile ? { display: 'block' } : {}}>
								<Button
									icon={<CloseCircleOutlined />}
									size="large"
									disabled={loadingButton}
									style={{ borderRadius: 10, ...(isMobile ? { width: '100%' } : {}) }}
								>
									Batal
								</Button>
							</Link>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SaveOutlined />}
								size="large"
								loading={loadingButton}
								disabled={errComponent}
								style={{
									borderRadius: 10,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								{isEdit ? 'Simpan Perubahan' : 'Tambah Layanan'}
							</Button>
						</div>
					</Card>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = function (state) { return state.configReducers; }

export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(FormLayanan);
